export default "__VITE_ASSET__$16kC9Bs__"